// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"260":"c8c9b95f","496":"6988145a","498":"ba8311b5","513":"6efff0f9","703":"69ae1d85"}[chunkId] + ".chunk.js";
};